import React from 'react';
import DataListAndSearch from '../../components/DataListAndSearch.jsx';
import DataCard from '../../components/DataCard.jsx';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSend from 'material-ui/svg-icons/content/send';
import ContentSave from 'material-ui/svg-icons/content/save';
import RetIvaForm from '../../components/Forms/RetIvaForm.jsx';
import ProveedorForm from '../../components/Forms/ProveedorForm.jsx';
import RetIva from '../../Models/RetIva.js';
import Factura from '../../Models/Factura.js';
import Dialog from 'material-ui/Dialog';

import ProveedorStore from '../../reflux/stores/ProveedorStore';
import ProveedorActions from '../../reflux/ProveedoresActions';
import RetIvaStore from '../../reflux/stores/RetIvaStore';
import RetIvaActions from '../../reflux/RetIvaActions';
import AuthStore from '../../reflux/stores/AuthStore';
import AlertActions from '../../reflux/AlertActions';
import Back from '../../components/Buttons/BackButton.jsx';
import _ from 'underscore';
import Check from 'material-ui/svg-icons/action/check-circle';

export default class RetIvaCreate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            proveedores: [],
            count: 0,
            retIva: new RetIva({}),
            proveedorEdit: false,
            sendMail: false,
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleFacturaInputChange = this.handleFacturaInputChange.bind(this);
        this.handleAgregarFactura = this.handleAgregarFactura.bind(this);
        this.handleQuitarFactura = this.handleQuitarFactura.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.retIvaStoreChange = this.retIvaStoreChange.bind(this);
        this.proveedorStoreChange = this.proveedorStoreChange.bind(this);
        this.handleProveedorInputChange = this.handleProveedorInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectProveedor = this.handleSelectProveedor.bind(this);
        this.handleRetIvaInputChange = this.handleRetIvaInputChange.bind(this);
        this.toggleMail = this.toggleMail.bind(this);

    }

    componentWillMount() {
        if (!AuthStore.getCliente().active_suscripcion)
            this.props.router.push('/expired');

        const back = (
            <Back onTouchTap={this.props.router.goBack}
                iconProps={{color:"white"}}/>
            );
        AlertActions.configureAppBar('Retenciones de I.V.A.', back);
        AlertActions.startLoading();
        if (this.props.params.id) {
            RetIvaActions.getRetIva(this.props.params.id);
        } else {
            ProveedorActions.getProveedores();
        }
    }

    //Connect to RetIvaStore
    componentDidMount() {
        this.unsubscribe = RetIvaStore.listen(this.retIvaStoreChange);
        this.unsubscribePro = ProveedorStore.listen(this.proveedorStoreChange);
    }

    //Disconnect from RetIvaStore
    componentWillUnmount() {
        this.unsubscribe();
        this.unsubscribePro();
    }

    /**
     * Handles changes in the ProveedorStore
     *
     * @param {string} e The event being fired
     * @param {Array} or {Object} proveedores Can be either an array of Proveedor
     * or a single Proveedor.
     * @param {number} proxima The next retencion
     */
    proveedorStoreChange(e, proveedores, count,  proxima) {
        if (e === 'getProveedores') {
            let retIva = this.state.retIva;
            retIva.proveedor = null;
            this.setState({proveedores: proveedores, retIva: retIva, count: count});
        }

        if (e === 'getProveedor' && !_.isEqual(proveedores, this.state.retIva.proveedor)) {
            let retIva = this.state.retIva;
            retIva.numero = proxima;
            retIva.proveedor = proveedores;
            retIva.facturas = this.state.retIva.facturas || [new Factura({percentage: proveedores.percentage})];

            this.setState({
                retIva: retIva,
            });
        }

        if (e === 'putProveedor') {
            let retIva = this.state.retIva;
            retIva.proveedor = proveedores;
            this.setState({
                retIva: retIva,
                proveedorEdit: false
            });
        }

        if (e === 'filter') {
            this.setState({
                proveedores: proveedores,
            });
        }

    }

    /**
     * Detects changes in RetIVaStore
     *
     * @param {string} e The even being fired
     * @param {RetIva} data The Retiva that was created
     *
     */
    retIvaStoreChange(e, data, sentByMail) {
        let sent = null;

        if (sentByMail === "true")
            sent = (
                <p><img src="/public/images/mail-sent.gif" alt=""/>Su comprobante ha sido enviado por correo electronico</p>
            );

        if (e === 'postedRetIva') {
            const title = <div>Comprobante Creado <Check color="green" /></div>;
            const msg = (
                <div>
                    <p>Ha creado satisfactoriamente un comprobante de retención de I.V.A. con el N° {data.numeroRet} perteneciente a {data.proveedor.name}</p>
                    {sent}
                </div>
            );
            AlertActions.alert('open', title, msg);
            this.props.router.push('/retiva');
        }

        if (e === 'getRetIva') {
            this.setState({retIva: data});
        }

        if (e === 'putRetIva') {
            const msg = <div>Comprobante Editado <Check color="green" /></div>;
            AlertActions.alert('open', msg, 'Ha editado satisfactoriamente un comprobante de retención de I.V.A. con el N° '+data.numeroRet+' perteneciente a '+data.proveedor.name);
            this.props.router.push('/retiva');
        }
    }

    /**
     * Select a Proveedor to make a RetIva
     *
     * @param {number} id The index of the proveedor in this.state.proveedores
     *
     */
    handleSelectProveedor(id) {
        const proveedor = this.state.proveedores[id];
        ProveedorActions.getProveedor(proveedor.id);
    }

    /**
     * Adds up to 4 extra invoice elements
     */
    handleAgregarFactura() {
        if (this.state.retIva.facturas.length <= 4) {
            let retIva = this.state.retIva,
                nueva = new Factura({percentage: retIva.proveedor.percentage});
            retIva.facturas.push(nueva);
            this.setState({retIva: retIva});
        }
    }

    /**
     * Removes the selected invoice elements
     *
     * @param {number} line The line to be removed
     *
     */
    handleQuitarFactura(line) {
        if (line !== 1) {
            let retIva = this.state.retIva;
            retIva.facturas.splice(line-1, 1);
            this.setState({retIva: retIva});
        }
    }

    /**
     * Debounced function in children that updates facturas state on any
     * input change
     *
     * @param {Factura} factura The new state of the modified factura
     * @param {number} line The line of the corresponding factura
     */
    handleFacturaInputChange(factura, line, blur) {

        let retIva = this.state.retIva;
        retIva.facturas[line-1] = factura;
        this.setState({retIva: retIva});
        if (blur) this.render();
    }

    handleRetIvaInputChange(e, value) {
        console.log(value);
        let retIva = this.state.retIva;
        retIva.number = value;

        this.setState({retIva: retIva});
    }

    /**
     * Handle Date Change
     *
     * @param {string} e The event that was fired
     * @param {Date} date The new Date
     *
     */
    handleDateChange(e, date) {
        let retiva = this.state.retIva;
        retiva.fecha = date;
        this.setState({retIva: retiva});
    }

    /**
     * Handles search according to query received from TextField
     *
     * @param {string} q The search query
     *
     */
    handleSearch(q) {
        AlertActions.startLoading();
        ProveedorActions.apiFilter(q);
    }

    /**
     * Handles submitting the RetIvaForm
     *
     * @return {void}
     */
    handleSubmit(action, e) {
        AlertActions.startLoading();
        if (action === 'submit')
            RetIvaActions.postRetIva(this.state.retIva, this.state.sendMail);
        if (action === 'save')
            RetIvaActions.putRetIva(this.state.retIva, this.state.sendMail);
    }

    /**
     * Opens modal for proveedor editing
     *
     * @return {void}
     */
    handleEdit() {
        this.setState({proveedorEdit: true});
    }

    /**
     * Handles actions from the Proveedor Edit Modal
     *
     * @param {string} e The action thas was taken
     * @return {void}
     *
     */
    handleProveedorActions(e) {
        switch(e) {
            case 'save':
                ProveedorActions.putProveedor(this.state.retIva.proveedor);
                break;
            case 'cancel':
                this.setState({proveedorEdit: false});
                break;
        }
    }

    /**
     * Handles input change when editing a proveedor
     *
     * @param {string} e The action thas was taken
     * @return {void}
     *
     */
    handleProveedorInputChange(e) {
        let retIva = this.state.retIva,
            proveedor = retIva.proveedor.handleInputChange(e);

        this.setState({retIva: retIva});
    }

    toggleMail(e, val) {
        this.setState({sendMail:val});
    }

    render() {
        //Create ProveedorForm for editing Proveedor
        const form = (
            <ProveedorForm
                proveedor={this.state.retIva.proveedor}
                handleChange={this.handleProveedorInputChange} />
        );

        //Create the Actions to be taken on the ProveedorForm
        const actions = (
            <div>
                <FlatButton
                    label="Guardar"
                    onTouchTap={this.handleProveedorActions.bind(this, 'save')} />

                <FlatButton
                    label="Cancelar"
                    onTouchTap={this.handleProveedorActions.bind(this, 'cancel')} />
            </div>
        );

        let view = null;
        //SHOW THE PROVEEDOR SEARCH IF THERE'S NOT ONE SELECTED
        if (this.state.retIva.proveedor === null || this.state.retIva.proveedor === undefined) {
            view = (
                <div className="retivacontainer">
                    <DataListAndSearch
                        searchTitle="Seleccione un proveedor"
                        onChangeInput={this.handleSearch}
                        handleEdit={() => ''}
                        handleSelect={this.handleSelectProveedor}
                        inputPlaceHolder="Buscar proveedor..."
                        criterios="nombre o rif del proveedor."
                        items={this.state.proveedores}
                        count={this.state.count}
                        rightButtonUseThis={true}
                        resourceName="proveedor"
                        showAddButton={false}
                        retencion={true}
                    />
                </div>
            );

        //OTHERWISE SHOW PROVEEDOR DATA AND RETIVA FORM
        } else {
            let list = (
                <div className="row" style={{marginLeft:0}}>
                    <div className="col-xs-12" style={{paddingLeft:0}}><strong>Email:</strong> {this.state.retIva.proveedor.email} </div>
                    <div className="col-xs-12" style={{paddingLeft:0}}><strong>Teléfono:</strong> {this.state.retIva.proveedor.phone} </div>
                </div>
            );

            let floatingButton = this.props.params.id
            ? (
                <FloatingActionButton
                    disabled={false}
                    style={{position: 'absolute', right:0, bottom: -50, zIndex: 2}}
                    onTouchTap={this.handleSubmit.bind(this, 'save')}>
                    <ContentSave />
                </FloatingActionButton>
            )

            : (
                <FloatingActionButton
                    disabled={false}
                    style={{position: 'absolute', right:0, bottom: -50, zIndex: 2}}
                    onTouchTap={this.handleSubmit.bind(this, 'submit')}>
                    <ContentSend />
                </FloatingActionButton>
            );

            // const actionProveedor = <FlatButton label="Editar" onTouchTap={this.handleEdit} />;
            const actionProveedor = null;
            view = (
                <div className="retivacontainer">
                    <DataCard
                        cardTitle={this.state.retIva.proveedor.primaryText}
                        cardSubtitle={this.state.retIva.proveedor.secondaryText}
                        inner={list}
                        actions={actionProveedor} />

                    <Dialog
                    title="Editar Proveedor"
                    open={this.state.proveedorEdit}
                    modal={true}
                    actions={actions}
                    autoDetectWindowHeight={false}
                    autoScrollBodyContent={true}
                    >
                        {form}
                    </Dialog>

                    <RetIvaForm
                        handleInputChange={this.handleFacturaInputChange}
                        handleRetIvaInputChange={this.handleRetIvaInputChange}
                        handleAgregarFactura={this.handleAgregarFactura}
                        handleQuitarFactura={this.handleQuitarFactura}
                        handleDateChange={this.handleDateChange}
                        retiva={this.state.retIva}
                        sendMail={this.state.sendMail}
                        mail={this.state.retIva.proveedor.email}
                        toggleMail={this.toggleMail} />

                    {floatingButton}
                </div>
            );
        }

        //RENDER THE VIEW

        let title = this.props.params.id
        ? <h2 className="center">Editar Retención de I.V.A.</h2>
        : <h2 className="center">Nueva Retención de I.V.A.</h2>;
        return (
            <div>
                {title}
                {view}
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./app-react/pages/RetIva/RetIvaCreate.jsx
 **/